import {ClientEventService} from "../../../services/client-events/ClientEventService";
import {
    AchievementUnlockedClientEventRecord,
    isAchievementUnlockedClientEvent
} from "../../../services/client-events/models/ClientEventRecord";
import {achievementPopupTemplate} from "../popup/AchievementTemplate";
import {AppUtil} from "../../../js/util/AppUtil";

export class AchievementPopupService {

    public static readonly id = "achievementPopupService";

    private readonly recentAchievements: Array<AchievementUnlockedClientEventRecord> = [];

    /** @ngInject */
    public constructor(private readonly clientEventService: ClientEventService) {
    }

    public start() {
        this.clientEventService
            .events()
            .filter(isAchievementUnlockedClientEvent)
            .subscribe((event) => this.addEventToQueue(event));
    }

    private addEventToQueue(event: AchievementUnlockedClientEventRecord) {
        this.recentAchievements.push(event);

        if (this.recentAchievements.length === 1) {
            this.showNextAchievementPopup();
        }
    }

    private showNextAchievementPopup() {
        const nextAchievement = this.recentAchievements.shift();
        if (nextAchievement == null) {
            return;
        }

        const id = AppUtil.uuid();
        const template = achievementPopupTemplate(id, nextAchievement.name, nextAchievement.value);
        const fragment = document.createRange().createContextualFragment(template);
        document.body.appendChild(fragment);
        const element = document.getElementById(id);

        if (element != null) {
            const autoHideTimer = setTimeout(() => {
                this.hideCurrentPopup(element);
            }, 10000);

            element.addEventListener("click", () => {
                this.hideCurrentPopup(element, autoHideTimer);
            });
        }
    }

    private hideCurrentPopup(element: HTMLElement, autoHideTimer: number | null = null) {
        element.parentElement!.removeChild(element);

        if (autoHideTimer != null) {
            clearTimeout(autoHideTimer);
        }

        this.showNextAchievementPopup();
    }
}
